import ImportUpdateDialog from "components/features/SME/importUpdateDialog";
import { useState } from "react";
import { useAppSelector } from "redux/hooks";
import CreateList from "./CreateList";

export const CreateListDialog = (props: any) => {
  const isCreateInnCodeModal = useAppSelector((state) => state.CorpDashboard.isCreateInnCodeModal);
  const uploadOrCreate = useAppSelector((state) => state.CorpDashboard.uploadOrCreate);
  const [uploadFileDetails, setUploadFileDetails] = useState({});
  const [invalidInnCodes, setInvalidInncodes] = useState([]);

  return (
    <>
      {isCreateInnCodeModal && (
        <CreateList
          listType={uploadOrCreate}
          setInvalidInncodes={setInvalidInncodes}
          invalidInnCodes={invalidInnCodes}
          setUploadFileDetails={setUploadFileDetails}
          uploadFileDetails={uploadFileDetails}
        />
      )}
      <ImportUpdateDialog
        uploadFileDetails={uploadFileDetails}
        invalidInncodes={invalidInnCodes}
        setInvalidInncodes={setInvalidInncodes}
      />
    </>
  );
};
